import { ComponentType } from 'react';

import { Element, Processor } from '@/features/html2react/types';

import DefinitionList from '../components/definition-list';

interface DefinitionListProcessorElement extends Element {
  props: Element['props'];
}

const definitionList: Processor<DefinitionListProcessorElement> = {
  priority: 10,
  name: 'definition-list',
  test: ({ node }) => !!node.props?.className && node.props.className.includes('wp-block-erom-definition-list'),
  processor: ({ node }) => {
    node.component = DefinitionList as ComponentType;

    return node;
  }
};

export default definitionList;
